import { HTMLAttributes } from 'react'
import { map } from 'lodash'

import BorderedCard from '@/components/base/bordered-card'
import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { WPLink, WPMedia } from '@/types'

export type CardsProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    pretitle: string
    title: string
    collection: {
      caption: string
      media: WPMedia
      link: WPLink
    }[]
  }>

const Cards = ({ pretitle, title, collection, ...props }: CardsProps) => {
  return (
    <Section {...props}>
      <Container>
        <Grid className="gap-y-[3rem]">
          <Grid className="col-span-2 gap-x-gutter md:col-span-6 lg:col-span-3 lg:grid-cols-3">
            <div className="col-span-2 md:col-span-4 lg:col-span-3">
              <div className="grid gap-y-[3rem]">
                {pretitle ? (
                  <Typography variant="upper-small" className="font-bold uppercase">
                    {pretitle}
                  </Typography>
                ) : null}
                {title ? (
                  <Typography variant="main-title-default" component="h3">
                    {title}
                  </Typography>
                ) : null}
              </div>
            </div>
          </Grid>

          {map(collection, ({ caption, media, link }, index) => (
            <BorderedCard
              key={`card-${index}`}
              image={media.image}
              title={caption}
              link={link.url}
              fill={true}
              className="relative col-span-2 md:col-span-2 lg:col-span-3"
            />
          ))}
        </Grid>
      </Container>
    </Section>
  )
}

export default Cards
